import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { BUSINESS } from "@/lib/site";

export default function Thanks() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid="thanks-page" className="relative min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1 flex items-center rsm-grid-bg pt-28 pb-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-amber-400/40 bg-amber-500/10"
          >
            <Check size={38} className="text-amber-400" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-8 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white"
          >
            Thanks — we've got it.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="mt-5 text-lg leading-relaxed text-slate-300"
          >
            Your message has been received. A member of the Rolling Stone
            Marketing team will get back to you within one business day.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
            className="mt-8 rounded-2xl border border-white/10 bg-[#121927] p-6 text-left"
          >
            <p
              data-testid="thanks-sms-note"
              className="text-sm leading-relaxed text-slate-400"
            >
              If you opted in to text messages: message frequency varies
              (approximately 2-6 messages per month), and message and data rates
              may apply. Reply STOP to opt out and HELP for help at any time.
            </p>
            <p className="mt-4 text-sm text-slate-500">
              Questions in the meantime? Email{" "}
              <a
                href={`mailto:${BUSINESS.email}`}
                className="text-amber-400 hover:text-amber-300"
              >
                {BUSINESS.email}
              </a>{" "}
              or call{" "}
              <a
                href={BUSINESS.phoneHref}
                className="text-amber-400 hover:text-amber-300"
              >
                {BUSINESS.phone}
              </a>
              .
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <Link
              to="/"
              data-testid="thanks-home-link"
              className="mt-10 inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3.5 text-sm font-semibold text-white hover:border-amber-400/50 hover:text-amber-400 transition-colors"
            >
              <ArrowLeft size={16} /> Back to home
            </Link>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
